import React, { PureComponent } from "react";
import { connect } from "react-redux";
import { Route, Redirect } from "react-router-dom";

import withStyles from "@material-ui/core/styles/withStyles";
import Typography from "@material-ui/core/Typography";
import Input from "@material-ui/core/Input";
import InputLabel from "@material-ui/core/InputLabel";
import Button from "@material-ui/core/Button";
import CircularProgress from "@material-ui/core/CircularProgress";
import Tab from "./Tab";

import ExpansionPanel from "@material-ui/core/ExpansionPanel";
import ExpansionPanelDetails from "@material-ui/core/ExpansionPanelDetails";
import ExpansionPanelSummary from "@material-ui/core/ExpansionPanelSummary";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import { Checkbox } from "@material-ui/core";
import {
  selectTeamMember,
  createTeamRequest,
  getManagerTeamRequest
} from "../../services/manager/actions";
import Colors from "../../constants/Colors";
import algoliasearch from "algoliasearch/lite";
import { InstantSearch, SearchBox } from "react-instantsearch-dom";
import Hits from "./Hits";
import Avatar from "./Avatar";

const searchClient = algoliasearch(
  "MTMFJ78PRC",
  "a6400a80c85f1dcceaaddde616c096a3"
);

const styles = theme => ({
  main: {
    width: "90%",
    // flex: 1,
    flexDirection: "row",
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "center"
  },
  inputForm: {
    marginTop: 15,
    marginBottom: 15,
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "flex-start"
  },
  inputLabel: {
    marginRight: 10,
    marginLeft: 10
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    textOverflow: "ellipsis",
    overflow: "hidden",
    // whiteSpace: "nowrap",
    color: Colors.text,
    width: "90%"
  },
  title: {
    fontSize: theme.typography.pxToRem(15),
    marginBottom: 15,
    color: Colors.text
  },
  separator: {
    fontSize: theme.typography.pxToRem(15),
    marginBottom: 10,
    fontWeight: "bold",
    color: Colors.text
  },
  text: {
    fontSize: theme.typography.pxToRem(15),
    color: theme.palette.text.secondary
  },
  secondaryHeading: {
    fontSize: theme.typography.pxToRem(15),
    color: theme.palette.text.secondary
  },
  table: {
    minWidth: 700
  },
  root: {
    width: "90%",
    marginTop: theme.spacing.unit * 3,
    overflowX: "auto",
    marginBottom: 15
  },
  button: {
    marginLeft: 15
  },
  actionRow: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center"
  },
  rowSelected: {
    backgroundColor: Colors.lightGrey
  },
  expansionDiv: {
    flex: 1
  },
  details: {
    flexDirection: "row",
    flex: 1,
    alignItems: "center",
    justifyContent: "flex-start"
  },
  checkDiv: {
    height: "100%"
    // backgroundColor: "#fff"
  },
  mainTitle: {
    fontWeight: 500,
    marginBottom: 15
  },
  saveButton: {
    backgroundColor: Colors.main
  },
  searchBox: {
    width: "100%"
  },
  leftDiv: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flex: 3,
    marginTop: 15
  },
  rightDiv: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    flexDirection: "column",
    marginTop: 10,
    flex: 1
  },
  saveButtonDiv: {},
  selectedMembers: {
    width: "100%",
    display: "flex",
    flexWrap: "wrap",
    alignItems: "flex-start",
    justifyContent: "flex-start"
  },
  selectedNumber: {
    color: Colors.text
  },
  number: {
    color: Colors.main,
    fontWeight: "bold"
  }
});

const isNumber = n => {
  return !isNaN(parseFloat(n)) && isFinite(n);
};

class Selection extends PureComponent {
  state = {
    expanded: null
  };

  componentDidMount() {
    this.props.getManagerTeamRequest(this.props.userId);
  }

  handleChange = panel => (event, expanded) => {
    this.setState({
      expanded: expanded ? panel : false
    });
  };

  onSubmit = () => {
    this.props.createTeamRequest({
      userId: this.props.userId,
      selectionList: this.props.selectionList
    });
    // this.props.updateSelectionRequest({
    //   clientId: this.props.clientId,
    //   actionsSelected: this.props.selectionList
    // });
  };

  onCheck = actionId => () => {
    this.props.checkAction(actionId);
  };

  onSelect = userId => () => {
    this.props.selectTeamMember(userId);
    // this.onSubmit();
  };

  render() {
    const { classes } = this.props;
    const { expanded } = this.state;

    return (
      <div className={classes.main}>
        <div className={classes.leftDiv}>
          <InstantSearch
            searchClient={searchClient}
            indexName={this.props.clientId}
          >
            <div className={classes.searchBox}>
              <SearchBox
                translations={{
                  placeholder: "Rechercher un membre..."
                }}
              />
            </div>
            <Hits
              selectTeamMember={this.onSelect}
              selectionList={this.props.selectionList}
            />
          </InstantSearch>
        </div>
        <div className={classes.rightDiv}>
          <div className={classes.saveButtonDiv}>
            {this.props.requesting ? (
              <CircularProgress />
            ) : (
              <Button
                onClick={this.onSubmit}
                disabled={
                  this.props.selectionList.length < 1 &&
                  this.props.managerTeam.length < 1
                }
                variant="contained"
                color="primary"
              >
                Constituer l'équipe
              </Button>
            )}
          </div>
          <p className={classes.selectedNumber}>
            <span className={classes.number}>
              {this.props.selectionList.length}
            </span>{" "}
            membres sélectionnés
          </p>
          <div className={classes.selectedMembers}>
            {this.props.selectionList.map(el => {
              return (
                <Avatar
                  key={el._id}
                  id={el._id}
                  onClick={this.onSelect(el)}
                  firstName={el.firstName}
                  lastName={el.lastName}
                  picture={el.picture}
                  isSelected
                />
              );
            })}
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  const { selectionList, requesting, tabSelected, managerTeam } = state.manager;
  const { clientId, userId } = state.client;
  return {
    clientId,
    managerTeam,
    userId,
    selectionList,
    requesting,
    tabSelected
  };
};

export default connect(
  mapStateToProps,
  {
    selectTeamMember,
    createTeamRequest,
    getManagerTeamRequest
  }
)(withStyles(styles)(Selection));
